export const MAX_TEXT_LENGTH_FOR_EXPAND = 500;

export const DOCUMENTATION_TIME_PLACEHOLDER = '--';
